// @ts-nocheck
import { get, post, patch, put, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * Busca clientes com filtros e paginacao
 * @param {ClienteFilters} filters - Filtros para a busca
 * @returns {Promise<ClientesResponse>} Resposta com lista de clientes
 */
export const getClientes = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/clientes?${queryParams.toString()}`;
    const response = await get(url);
    return (response?.data || response || {
        registros: [],
        totalRegistros: 0,
        paginaAtual: Number(filters.pagina) || 0,
        quantidadePorPagina: Number(filters.quantidadePorPagina) || 0,
    });
};
let clientes = getClientes;
/**
 * Busca um cliente especifico por ID
 * @param {number} id - ID do cliente
 * @returns {Promise<Cliente>} Dados do cliente
 */
export const getClienteById = async (id) => {
    const response = await get(`${API_URL}/clientes/${id}`);
    return response?.data || response;
};
/**
 * Cria um novo cliente
 * @param {ClienteCreatePayload} payload - Dados do cliente a ser criado
 * @returns {Promise<Cliente>} Cliente criado
 */
export const createCliente = async (payload) => {
    const response = await post(`${API_URL}/clientes`, payload);
    return response?.data || response;
};
/**
 * Atualiza um cliente existente
 * @param {number} id - ID do cliente
 * @param {ClienteCreatePayload} payload - Dados atualizados do cliente
 * @returns {Promise<Cliente>} Cliente atualizado
 */
export const updateCliente = async (id, payload) => {
    const response = await put(`${API_URL}/clientes/${id}`, payload);
    return response?.data || response;
};
/**
 * Exclui um cliente
 * @param {number} id - ID do cliente a ser excluido
 * @returns {Promise<void>}
 */
export const deleteCliente = async (id) => {
    await deleteRequest(`${API_URL}/clientes/${id}`);
};
/**
 * Busca clientes por termo de busca (nome ou CNPJ)
 * @param {string} searchTerm - Termo de busca
 * @returns {Promise<Cliente[]>} Lista de clientes encontrados
 */
export const searchClientes = async (searchTerm) => {
    const response = await get(`${API_URL}/clientes/buscar?search=${encodeURIComponent(searchTerm)}`);
    return response?.data || response || [];
};
/**
 * Cria um ou varios emails para um cliente
 * @param {{ ClienteId: number, Emails: string[] }} payload
 * @returns {Promise<any>}
 */
export const createClienteEmails = async (payload) => {
    const response = await post(`${API_URL}/cliente-emails`, payload);
    return response?.data || response;
};
/**
 * Lista emails de clientes com filtros e paginacao
 * @param {Record<string, string | number>} filters
 * @returns {Promise<any>}
 */
export const getClienteEmails = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const query = queryParams.toString();
    const response = await get(`${API_URL}/cliente-emails${query ? `?${query}` : ''}`);
    return response?.data || response;
};
/**
 * Lista todos os emails vinculados a um cliente
 * @param {number|string} clienteId
 * @returns {Promise<any>}
 */
export const getClienteEmailsByClienteId = async (clienteId) => {
    const response = await get(`${API_URL}/cliente-emails/cliente/${clienteId}`);
    return response?.data || response || [];
};
/**
 * Busca email de cliente por ID
 * @param {number} id
 * @returns {Promise<any>}
 */
export const getClienteEmailById = async (id) => {
    const response = await get(`${API_URL}/cliente-emails/${id}`);
    return response?.data || response;
};
/**
 * Atualiza email de cliente
 * @param {number} id
 * @param {Record<string, any>} payload
 * @returns {Promise<any>}
 */
export const updateClienteEmail = async (id, payload) => {
    const response = await patch(`${API_URL}/cliente-emails/${id}`, payload);
    return response?.data || response;
};
/**
 * Remove email de cliente
 * @param {number} id
 * @returns {Promise<void>}
 */
export const deleteClienteEmail = async (id) => {
    await deleteRequest(`${API_URL}/cliente-emails/${id}`);
};
